// src/components/shared/NicheSummaryCards.js
import React from 'react';
import { formatCurrency, formatNumber } from '../../utils/dashboardUtils';
import { NICHE_EMOJIS } from '../../constants/businessLogic';

const NicheSummaryCards = ({ niches = [] }) => {
  if (!niches || niches.length === 0) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="niche-card text-center" style={{ color: 'var(--color-neutral-500)' }}>
          Geen niche data beschikbaar
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6 mb-6 lg:mb-8">
      {niches.map((niche, index) => {
        const efficiency = niche.unique > 0 ? (niche.leadCalls / niche.unique * 100).toFixed(1) : '0.0';
        const avgRevenue = niche.leadCalls > 0 ? (niche.revenue / niche.leadCalls).toFixed(0) : '0';

        return (
          <div key={index} className="niche-card">
            {/* Header */}
            <div className="niche-header">
              <span className="niche-emoji">{NICHE_EMOJIS[niche.name] || '❓'}</span>
              <h3 className="niche-name">{niche.name}</h3>
            </div>

            {/* Stats */}
            <div className="niche-stats">
              <div className="niche-stat">
                <span className="niche-stat-label">Revenue</span>
                <span className="niche-stat-value success">{formatCurrency(niche.revenue)}</span>
              </div>
              <div className="niche-stat">
                <span className="niche-stat-label">Lead Calls</span>
                <span className="niche-stat-value">{formatNumber(niche.leadCalls)}</span>
              </div>
              <div className="niche-stat">
                <span className="niche-stat-label">Total Calls</span>
                <span className="niche-stat-value">{formatNumber(niche.calls)}</span>
              </div>
              <div className="niche-stat">
                <span className="niche-stat-label">Efficiency</span>
                <span className="niche-stat-value">{efficiency}%</span>
              </div>
              <div className="niche-stat">
                <span className="niche-stat-label">Avg/Lead</span>
                <span className="niche-stat-value">€{avgRevenue}</span>
              </div>
              <div className="niche-stat">
                <span className="niche-stat-label">Customers</span>
                <span className="niche-stat-value">{niche.customers || 0}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default NicheSummaryCards;
